(function () {
  'use strict';

  if (!document.querySelector('.js-submit')) return;

  const $submit = jQuery('.js-submit');

  /* 送信ボタンの有効 / 無効を更新  */
  function updateSubmit() {
    let allFilled = true;

    jQuery('.js-require').each(function () {
      const val = jQuery(this).val();
      if (val === '' || val === '----') {
        allFilled = false;
        return false;
      }
    });

    const privacyChecked = jQuery('.js-privacy').prop('checked');

    $submit.prop('disabled', !(allFilled && privacyChecked));
  }

  /* 電話番号：数字のみ入力を許可  */
  jQuery(document).on('input', '.js-form-tel', function () {
    jQuery(this).val(
      jQuery(this)
        .val()
        .replace(/[^0-9]/g, ''),
    );
    updateSubmit();
  });

  /* 水曜日（定休日）の選択を防止  */
  jQuery(document).on('change', '.js-date-wed', function () {
    const val = jQuery(this).val();
    if (!val) return;
    const parts = val.split('-').map(Number);
    const date = new Date(parts[0], parts[1] - 1, parts[2]);
    if (date.getDay() === 3) {
      jQuery(this).val('');
      alert('水曜日は定休日のため、別の日をお選びください。');
    }
    updateSubmit();
  });

  /* 各フィールドの変更を監視*/
  jQuery(document).on('input change', '.js-require', updateSubmit);
  jQuery(document).on('change', '.js-privacy', updateSubmit);

  /* 初期化  */
  updateSubmit();

  /* 送信完了後にサンクスページへリダイレクト  */
  document.addEventListener('wpcf7mailsent', function () {
    window.location.href = window.location.origin + '/contact/thanks/';
  });
})();
